import React, { useState} from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

function Changepassword() {
    const [formData, setFormData] = useState({
        current_password: '',
        new_password: '',
        confirm_password: '',
        username: ''
    });
    const [showPassword, setShowPassword] = useState({
        current_password: false,
        new_password: false,
        confirm_password: false
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const id = localStorage.getItem('user_id');
    const username = localStorage.getItem('email');
    formData.username = username;


    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const togglePasswordVisibility = (field) => {
        setShowPassword((prevState) => ({
            ...prevState,
            [field]: !prevState[field]
        }));
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        console.log(formData)

        // Validate if new_password and confirm_password match
        if (formData.new_password !== formData.confirm_password) {
            toastr.error('New password and confirm password do not match.');
            setLoading(false);
            return;
        }


        try {
            const response = await axios.put(`https://api.sivammoto.in/api/auth/changepassword/${id}`, formData);

            const data = response.data;
            console.log(data)
            // Store the token and update auth state
            localStorage.clear();
            toastr.success("Password Updated Successfully");
            navigate('/login');

            // Reset form and show success message
            setFormData({ current_password: '', new_password: '', confirm_password: '', username: '' });
        } catch (error) {
            if (error.response) {
                setError(error.response.data.error);
                console.log(error.response.data.error)
                toastr.error(error.response.data.error);
            } else {
                setError('An error occurred. Please try again.');
            }
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Change Password</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/">Home</a></li>
                                <li className="breadcrumb-item active">Change Password</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className='col-md-3'></div>

                <div className="col-md-6">
                    <div className="card card-warning">
                        <div className="card-header">
                            <h3 className="card-title">Change Password</h3>
                        </div>
                        <div className="card-body">
                            <form>
                                {['current_password', 'new_password', 'confirm_password'].map((field, index) => (
                                    <div className="col-sm-12" key={index}>
                                        <label>{field.replace('_', ' ').toUpperCase()} :</label>
                                        <div className="input-group mb-3">
                                            <input
                                                type={showPassword[field] ? "text" : "password"}
                                                name={field}
                                                value={formData[field]}
                                                onChange={handleChange}
                                                className="form-control"
                                            />
                                            <div className="input-group-append">
                                                <div className="input-group-text">
                                                    <a
                                                        className="fas fa-eye"
                                                        onClick={() => togglePasswordVisibility(field)}
                                                    ></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? 'Updating...' : 'Update'}
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Changepassword